angular.module('app').directive('bcMultiSelect', ['$filter', function ($filter) {

    return {
        restrict: "E",
        templateUrl: "views/directives/bc-multi-select.html",
        replace: true,
        require: 'ngModel',
        scope: {
            values: '=',
            labelField: '@',
            valueField: '@',
            useOnlyValue: '=', // true (default value) means in model will be saved only values: [1,2,3], false means will be saved objects with Value and Label pair: [{"Name":"aaa","Id":1},{"Name":"bbb","Id":2},{"Name":"ccc","Id":3}]
            showSelectAll: '=',
            bcViewMode: '=',
            showSearchBar: '=',
            disabled: '=',
            loading: '='
        },
        link: function multiSelectLink(scope, element, attrs, ctrl) {
            var $wrapper = element.find('.bc-multi-select-wrapper');

            scope.labelField = scope.labelField || "Name";
            scope.valueField = scope.valueField || "Id";

            var useOnlyValue = scope.useOnlyValue !== false; // make default value to TRUE

            var generateString = function () {
                var text = "";
                var possible = "abcdefghijklmnopqrstuvwxyz";

                for (var i = 0; i < 8; i++) {
                    text += possible.charAt(Math.floor(Math.random() * possible.length));
                }

                return text;
            };

            scope.fieldId = generateString();
            scope.state = {};
            scope.state.searchText = '';

            /**
             * @description
             * This part is for implementing ng-model
             * It provides two way binding between our directive
             * and real ng-model of input
             */
            if (!ctrl)
                return;

            scope.model = {
                multiSelectModel: null
            };

            ctrl.$render = function () {
                scope.model.multiSelectModel = ctrl.$viewValue || [];

                if (scope.model.multiSelectModel.length === 0) {
                    setDefaultValues();
                } else {
                    if (scope.values && scope.values.length) {
                        parseModelData();
                    }
                }
            };

            scope.$watch('model.multiSelectModel', function (newVal) {
                ctrl.$setViewValue(newVal);
            });

            /**
             * Display options in textbox
             * @return {String} Display string
             */

            function getOptionDisplayName(item) {
                if (useOnlyValue) {
                    for (var i = 0; i < scope.values.length; i++) {
                        if (item === scope.values[i][scope.valueField]) {
                            return scope.values[i][scope.labelField];
                        }
                    }
                } else {
                    return item[scope.labelField];
                }
            }

            scope.displayOptions = function displayOptions() {
                var label = '';

                if (scope.loading) {
                    label = $filter('translate')('_IsLoading_');

                } else if (scope.model.multiSelectModel.length === 1) {
                    label = getOptionDisplayName(scope.model.multiSelectModel[0]);

                } else if (scope.model.multiSelectModel.length === 2) {
                    label = getOptionDisplayName(scope.model.multiSelectModel[0]) + ", " + getOptionDisplayName(scope.model.multiSelectModel[1]);

                } else if (scope.model.multiSelectModel.length > 1) {
                    label = $filter('translate')('_SelectedCount_', {count: scope.model.multiSelectModel.length});

                } else {
                    label = $filter('translate')('_NoneSelected_');
                }

                return label;
            };

            //check for values change
            scope.$watchGroup(['values', 'loading'], function (newValue) {
                if (scope.values && scope.values.length) {
                    if (scope.model.multiSelectModel.length) {
                        parseModelData();
                    }

                    scope.updateModel();
                }
            });

            // Show/hide dropdown
            scope.toggleDropdown = function toggleDropdown() {
                if ($wrapper.hasClass('hide-drop-down')) {
                    // close all other dropdowns on the page before showing the selected one
                    angular.element('body').find('.bc-multi-select-wrapper').removeClass('show-drop-down').addClass('hide-drop-down');
                    $wrapper.removeClass('hide-drop-down').addClass('show-drop-down');
                    if (scope.showSearchBar) {
                        scope.focusSearch = true;
                    }
                } else {
                    $wrapper
                        .removeClass('show-drop-down')
                        .addClass('hide-drop-down');
                    scope.focusSearch = false;
                }
            };

            scope.getFilterObject = function (searchText) {
                var filterObject = {};
                filterObject[scope.labelField] = searchText || '';

                if(scope.bcViewMode) {
                    filterObject.isChecked = true;
                }

                return filterObject;
            };

            function parseModelData() {
                scope.values.forEach(function (item) {
                    item.isChecked = false;

                    if (useOnlyValue) {
                        if (scope.model.multiSelectModel.indexOf(item[scope.valueField]) !== -1) {
                            item.isChecked = true;
                        }
                    } else {
                        scope.model.multiSelectModel.forEach(function (modelItem) {
                            if (modelItem[scope.valueField] === item[scope.valueField]) {
                                item.isChecked = true;
                            }
                        });
                    }
                });
            }

            function setDefaultValues() {
                var tmpModel = [];
                scope.values.forEach(function (item) {
                    if (item.isDefault) {
                        item.isChecked = true;

                        if (useOnlyValue) {
                            tmpModel.push(item[scope.valueField]);
                        } else {
                            var tmpItem = {};
                            tmpItem[scope.labelField] = item[scope.labelField];
                            tmpItem[scope.valueField] = item[scope.valueField];
                            tmpModel.push(tmpItem);
                        }
                    } else {
                        item.isChecked = false;
                    }
                });

                scope.model.multiSelectModel = tmpModel;
            }

            scope.updateModel = function (item) {
                var tmpModel = [];

                scope.values.forEach(function (item) {
                    if (item.isChecked) {
                        if (useOnlyValue) {
                            tmpModel.push(item[scope.valueField]);
                        } else {
                            var tmpItem = {};
                            tmpItem[scope.labelField] = item[scope.labelField];
                            tmpItem[scope.valueField] = item[scope.valueField];
                            tmpModel.push(tmpItem);
                        }
                    }
                });

                scope.model.multiSelectModel = tmpModel;
                scope.checkIsAllSelected();
            };

            scope.checkIsAllSelected = function () {
                var items = [];

                items = $filter('filter')(scope.values, scope.getFilterObject(scope.state.searchText));

                if (items.length === 0) {
                    scope.allSelectionChecked = false;
                    return false;
                }

                for (var i = 0; i < items.length; i++) {
                    if(!items[i].isChecked) {
                        scope.allSelectionChecked = false;
                        return false;
                    }
                }

                scope.allSelectionChecked = true;
                return true;
            };

            scope.checkAllItems = function () {
                var items = [];

                items = $filter('filter')(scope.values, scope.getFilterObject(scope.state.searchText));

                items.forEach(function (item) {
                    item.isChecked = scope.allSelectionChecked;
                });

                scope.updateModel();
            };

            scope.selectValue = function selectValue(event) {
                if (event.which == 13 || event.keyCode == 13) {
                    event.preventDefault();
                    var values = $filter('filter')(scope.values, scope.getFilterObject(scope.state.searchText));
                    if (values.length > 0) {
                        var length = values.length;
                        for (var i = 0; i < length; ++i) {
                            if (!values[i].isChecked) {
                                values[i].isChecked = true;
                                scope.state.searchText = '';
                                scope.updateModel();
                                break;
                            }
                        }
                    }
                }
            };

            // hide dropdown when clicking away
            function hideDropdownClick(e) {
                if ($(e.target).closest(".bc-multi-select-wrapper").length === 0 &&
                    typeof e.target.className === "string" && e.target.className.indexOf('multi-select-input') === -1) {
                    $wrapper.removeClass('show-drop-down').addClass('hide-drop-down');
                }
            }

            // hide dropdown when pressing ESC
            function hideDropdownEsc(e) {
                if (e.which === 27 && $wrapper.hasClass('show-drop-down')) {
                    e.preventDefault();
                    $wrapper.removeClass('show-drop-down').addClass('hide-drop-down');
                }
            }

            function stopUnexpectedPropagation(event) {
                if (scope.bcViewMode) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            }

            $('body').on('click', hideDropdownClick).on('keydown', hideDropdownEsc);
            $wrapper.find('.multi-select-dropdown').on('click', stopUnexpectedPropagation);

            scope.$on('$destroy', function () {
                $('body').off('click', hideDropdownClick).off('keydown', hideDropdownEsc);
                $wrapper.find('.multi-select-dropdown').off('click', stopUnexpectedPropagation);
            });
        }
    }
}]);
